var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryIq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8778)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8778)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 8.53934C18.6667 8.29155 18.9275 8.13039 19.1492 8.2412L19.8158 8.57454C19.9287 8.631 20.0001 8.74642 20.0001 8.87268V11.6667C20.0001 11.8508 19.8508 12 19.6667 12H19.0001C18.816 12 18.6667 11.8508 18.6667 11.6667V8.53934Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 8.53934C10.6667 8.29155 10.9275 8.13039 11.1492 8.2412L11.8158 8.57454C11.9287 8.631 12.0001 8.74642 12.0001 8.87268V11.6667C12.0001 11.8508 11.8508 12 11.6667 12H11.0001C10.816 12 10.6667 11.8508 10.6667 11.6667V8.53934Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.87268C16 8.74642 16.0713 8.631 16.1843 8.57454L16.8509 8.2412C17.0726 8.13039 17.3333 8.29155 17.3333 8.53934V11.6667C17.3333 11.8508 17.1841 12 17 12H16.3333C16.1492 12 16 11.8508 16 11.6667V8.87268Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 10.206C13.3333 10.0797 13.4046 9.96431 13.5175 9.90784L14.1842 9.57451C14.4058 9.46369 14.6666 9.62486 14.6666 9.87265V10.7264H16.6666V12H14.6666H13.6666C13.4825 12 13.3333 11.8507 13.3333 11.6666V10.206Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.206C8 10.0797 8.07133 9.96431 8.18426 9.90784L8.85093 9.57451C9.07256 9.46369 9.33333 9.62486 9.33333 9.87265V10.7264H11.3333V12H9.33333H8.33333C8.14924 12 8 11.8507 8 11.6666V10.206Z",
    fill: "#0F7A40"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8778"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIq);
export default __webpack_public_path__ + "static/media/Country=IQ.ae261c1524de07b4ef9bac2bd4a14d3f.svg";
export { ForwardRef as ReactComponent };